"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransportDeliveredRowInfo = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _languageService = _interopRequireDefault(require("hh-shared/dist/language/services/languageService"));

var _Row = _interopRequireDefault(require("../layout/Row"));

var _ColoredTime = _interopRequireDefault(require("../commons/DataFixTimes/ColoredTime"));

var _Attachment = _interopRequireDefault(require("../commons/Attachment"));

var _IconArea = _interopRequireDefault(require("../commons/IconArea"));

var _icons = _interopRequireDefault(require("../commons/FontAwesomeIcon/icons"));

var _Column = _interopRequireDefault(require("../layout/Column"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TransportDeliveredRowInfo = function TransportDeliveredRowInfo(_ref) {
  var data = _ref.data,
      onDownloadAttachment = _ref.onDownloadAttachment;

  if (!data.deliveryDate) {
    return null;
  }

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Row.default, null, _react.default.createElement(_Column.default, null, _react.default.createElement(_IconArea.default, {
    icon: _icons.default.deliverMark,
    iconTitle: _languageService.default.labels.DeliveryDate()
  }, _react.default.createElement("span", null, _languageService.default.labels.DeliveryDate()), _react.default.createElement("div", null, _react.default.createElement(_ColoredTime.default, {
    time: data.deliveryDate
  })))), _react.default.createElement(_Column.default, null, _react.default.createElement(_IconArea.default, {
    icon: _icons.default.information,
    iconTitle: _languageService.default.labels.InvoiceNumber()
  }, _react.default.createElement("span", null, _languageService.default.labels.InvoiceNumber()), _react.default.createElement("div", null, data.invoiceNumber)))), _react.default.createElement(_Row.default, null, _react.default.createElement(_IconArea.default, {
    icon: _icons.default.dictionary,
    iconTitle: _languageService.default.labels.Attachments()
  }, _react.default.createElement("span", null, _languageService.default.labels.Attachments()), data.attachments.length === 0 && _react.default.createElement("span", null, _languageService.default.labels.Missing()), data.attachments.map(function (a) {
    return _react.default.createElement(_Attachment.default, {
      fileName: a.name,
      onDownload: function onDownload() {
        return onDownloadAttachment(a.id);
      }
    });
  }))));
};

exports.TransportDeliveredRowInfo = TransportDeliveredRowInfo;
TransportDeliveredRowInfo.propTypes = {
  data: _propTypes.default.object.isRequired,
  onDownloadAttachment: _propTypes.default.func.isRequired
};